import {
  useLottieAnimation
} from "./chunk-2DTQ5CXV.js";
import "./chunk-D4IWIVYX.js";

// src/index.ts
import React from "react";
var ConfettiAnimation = React.lazy(
  () => import("./confetti-animation.component-LCKUZRZQ.js")
);
export {
  ConfettiAnimation,
  useLottieAnimation
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/lottie'] = window.leagueSDKsPresent['@leagueplatform/lottie'] || [];
    window.leagueSDKsPresent['@leagueplatform/lottie'].push('2.27.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/lottie'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/lottie module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map